import { RailSettlementController } from './rail-settlement.controller';


/**
 * The entry point for the rail settlement module
 */
export const initialise = () => {
  angular.module('app.rail-settlement', [
    'pascalprecht.translate',
    'actora.services',
    'app.layout',
    'app.components',
    
  ])
    .config(['$stateProvider', '$urlRouterProvider', '$locationProvider', ($stateProvider, $urlRouterProvider, $locationProvider) => {
      $locationProvider.hashPrefix('');
      $stateProvider.state('rail-settlement', {
        url: '/rail-settlement',
        templateUrl: 'app/angularJS/features/abt/rail-settlement/rail-settlement.html',
        controller: 'railSettlementController',
        controllerAs: 'vm',
        parent: 'common'
      });
      $urlRouterProvider.otherwise('/');
    }])
    .controller('railSettlementController', <ng.IControllerConstructor>RailSettlementController);
};